/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Contact_Floor_RefusedInputs */



/**
* | output |
* | --- |
* | "As an NC or Prince you must keep at least one way for members to reach you: a contact email, a phone number or a linked Discord login." |
*
* @param {Profile_Contact_Floor_RefusedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_contact_floor_refused = /** @type {((inputs?: Profile_Contact_Floor_RefusedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Contact_Floor_RefusedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En tant que NC ou Prince, vous devez garder au moins un moyen pour les membres de vous joindre : un e-mail de contact, un téléphone ou un compte Discord lié.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Como NC o Príncipe debes conservar al menos una forma de que los miembros te contacten: un correo de contacto, un teléfono o una cuenta de Discord vinculada.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Como NC ou Príncipe você deve manter pelo menos uma forma de os membros o contatarem: um e-mail de contato, um telefone ou uma conta Discord vinculada.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Come NC o Principe devi mantenere almeno un modo per i membri di contattarti: un'email di contatto, un telefono o un account Discord collegato.")
	return /** @type {LocalizedString} */ ("As an NC or Prince you must keep at least one way for members to reach you: a contact email, a phone number or a linked Discord login.")
});